import { HttpClient } from '../../httpClient.js'

export async function reset(
  httpClient: HttpClient,
  eventId: number,
): Promise<void> {
  return httpClient.url(`/events/${eventId}/reset`).post().json()
}
